import { de } from './de';
import { en } from './en';
import type { SupportedLanguage, TranslationSchema } from './types';

// Re-export types
export type { SupportedLanguage, TranslationSchema };

// Export the translations
export { de, en };

// Create a translations object with all languages
export const translations: Record<SupportedLanguage, TranslationSchema> = {
    de,
    en
};